import { useContext } from "react";

import moment, { Moment } from "moment";

import { useDatePicker } from "components/DatePicker";
import TimeZoneContext from "context/timeZone/timeZoneContext";

const useDatePickerRange = () => {
    const { currentTimeZone } = useContext(TimeZoneContext);

    const { getLocalDate } = useDatePicker();

    const isLocalToday = (value: Moment) => {
        const userNow = moment.tz(currentTimeZone);
        const userStartOfToday = userNow.clone().startOf("day");
        const userEndOfToday = userNow.clone().endOf("day");

        return getLocalDate(value).isBetween(
            userStartOfToday,
            userEndOfToday,
            undefined,
            "[]"
        );
    };

    const parseDateToUtc = (
        value: Moment | null,
        format: string,
        isStartDate?: boolean
    ) => {
        if (!value) return null;

        if (isStartDate) {
            return isLocalToday(value)
                ? moment.utc().format(format)
                : getLocalDate(value).utc().format(format);
        }

        return getLocalDate(value).clone().add(1, "day").utc().format(format);
    };

    const parseDate = (value: Moment | null, format: string) => {
        if (!value) return "";

        return moment(value).format(format);
    };

    return { parseDateToUtc, parseDate };
};

export { useDatePickerRange };
